import { render, staticRenderFns } from "./kraken.vue?vue&type=template&id=5b7c87bd"
import script from "./kraken.vue?vue&type=script&lang=js"
export * from "./kraken.vue?vue&type=script&lang=js"
import style0 from "./kraken.vue?vue&type=style&index=0&id=5b7c87bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports